import { render, staticRenderFns } from "./ModalFooter.vue?vue&type=template&id=66808654&scoped=true&"
import script from "./ModalFooter.vue?vue&type=script&lang=js&"
export * from "./ModalFooter.vue?vue&type=script&lang=js&"
import style0 from "./ModalFooter.vue?vue&type=style&index=0&id=66808654&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66808654",
  null
  
)

export default component.exports